export default __webpack_public_path__ + "static/media/Cross.c61e9f65.svg";